<template>
	<div>
		<v-container class="global-margin">
      		<v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
		</v-container>
		<v-container class="br-20 white card-content flex-center flex-column mt-6 pt-10 mb-10">
			<h1 class="text--primary w-100 text-center">Lekcije</h1>
			<p class="text--secondary w-100 text-center mt-5">
				Krajnji korisnici imaju mogućnost pregleda digitalnog sadržaja, prilagođenog uzrastu učenika, kojeg su izradili naši nastavnici.
				SUMIT je osigurao digitalni sadržaj za sve krajnje korisnike koji nemaju spremna online predavanja.
			</p>
			<div class="card-switch mt-5 flex-center">
				<div :class="{'active-switch': osnovna == true}" class="option-left flex-center" @click="changeType">
					<p class="ma-0 text-center w-100">Osnovna</p>
				</div>
				<div :class="{'active-switch': srednja == true}" class="option-right flex-center" @click="changeType">
					<p class="ma-0 text-center w-100">Srednja</p>
				</div>
			</div>
			<v-row v-if="osnovna" class="flex-center w-100 mt-10 class-list">
				<v-col v-for="(i, index) in razredi[0]" :key="index" cols="12" sm="6" md="4" class="pa-5">
					<router-link :to="'/predmeti/osnovna/' + i.grade" style="text-decoration: none;">
						<div class="class-item pa-5">
							<p class="blue-text text-uppercase font-weight-medium ma-0">
								<template v-if="i.grade == 10">
									Ostalo
								</template>
								<template v-else>
									{{ i.grade }}. Razred
								</template>
							</p>
							<v-icon color="#094776">keyboard_arrow_right</v-icon>
						</div>
					</router-link>
				</v-col>
			</v-row>
			<v-row v-if="srednja" class="flex-center w-100 mt-10 class-list">
				<v-col v-for="(i, key) in razredi[1]" :key="key" cols="12" sm="6" md="6" class="pa-5">
					<router-link :to="'/predmeti/srednja/' + i.grade" style="text-decoration: none;">
						<div class="class-item pa-5">
							<p class="blue-text text-uppercase font-weight-medium ma-0">
								{{ i.grade }}. Razred SŠ
							</p>
							<v-icon color="#094776">keyboard_arrow_right</v-icon>
						</div>
					</router-link>
				</v-col>
			</v-row>
			<div class="w-100 mt-5 pb-lg-10 pb-sm-12">
				<div class="w-100 px-5 mt-5 pb-lg-10 pb-sm-12">
						<div class="my-alert w-100 py-4 px-3 flex-between">
							<div class="flex-center">
								<v-icon color="teal" class="mr-2">query_builder</v-icon>
								<p v-if="osnovna" class="mb-0">Raspored nastave</p>
							</div>
							<v-btn rounded outlined color="teal" to="/raspored" class="moodle-btn text-capitalize">Pogledaj raspored</v-btn>
						</div>
					</div>
			</div>
		</v-container>
	</div>
</template>

<script>
export default {
	name: "Lekcije",
	data() {
		return {
			osnovna: true,
			srednja: false,
			razredi: [],
			breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
        },
        {
          text: 'Lekcije',
          disabled: true,
        },
      ],
		}
	},
	created() {
		skoleApi.get("razredi").then(response => {
			if(response.status === 200) {
				this.razredi = response.data;
			}
		})
	},
	methods: {
		changeType() {
			if (this.osnovna) {
				this.osnovna = false;
				this.srednja = true;
			} else {
				this.srednja = false;
				this.osnovna = true;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.lekcije {
    margin-top: 190px;
}
@media(max-width: 768px) {
	.lekcije {
		margin-top: 120px !important;
	}
}
.v-alert__wrapper {
	width: 100% !important;
}
.card-content {
	width: 80%;
	height: 80%;
	.card-switch {
		width: 50%;
		height: 56px;
		background-color: #F0F5F7;
		border-radius: 33px;

		.option-left,
		.option-right {
			width: 50%;
			height: 100%;
			border-radius: 33px;
			cursor: pointer;
		}
	}
}
.class-item {
	border: 1px solid #DEE7EA;
	border-radius: 4px;
	display: flex;
	justify-content: space-between;
	transition: .3s ease;
	cursor: pointer;
	&:hover {
		border: 1px solid #094776;
		transition: .3s ease;
	}
}
.moodle-btn {
	letter-spacing: 0 !important;
	border-radius: 30px;
}
@media (max-width: 768px) {
	.alert-wrap {
		div {
			align-items: flex-start;
			flex-direction: column;
			p {
				margin-top: 20px;
				margin-bottom: 20px !important;
			}
		}
		flex-direction: column !important;
		button {
			margin-top: 20px;
		}
	}
	.card-switch {
		width: 100% !important;
	}
}
.active-switch {
	background-color: #094776 !important;
	p {
		color: #FFFFFF !important;
	}
}
	.br-20{
		border-radius: 20px !important;
	}
</style>
